<template>
  <md-notice-bar class="noticetop" type="warning" mode="closable" icon="info" multi-rows v-if="shownotice"
    @close="closenotice">
    <div @click="showmessage">
      {{ content }}
    </div>
  </md-notice-bar>
</template>
  
<script>
import { unreadcount } from '@/request/api'
export default {
  name: 'noticetop',
  data() {
    return {
      content: "Welcome to TT Wallet, Please pay attention to the notice here!",
      notificationevent: null,
      unread_count: -1,
      shownotice: false
    }
  },
  watch: {
  },
  created() {
    if (this.notificationevent != null) {
      clearInterval(this.notificationevent);
    }
    this.notificationevent = setInterval(() => {
      if(localStorage.getItem('token')) {
        this.unreadcount();
      }
    }, 30000);
  },
  methods: {
    showmessage() {
      this.$router.push({ name: 'message' });
    },
    closenotice() {
      console.log("close");
      this.shownotice = false;
      return true;
    },
    unreadcount() {
      unreadcount().then(res => {
        console.log(res);
        this.unread_count = res.unread_count;
        if  (this.unread_count > 0) {
          this.content = "You have " + this.unread_count + " unread messages, please check it!";
          this.shownotice = true;
        }
      })
    },

  },
  beforeUnmount() {
    if (this.notificationevent != null) {
      clearInterval(this.notificationevent);
    }
  }
}
</script>
<style scoped>
.noticetop {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  z-index: 999;
  position: fixed;
  padding-left: 0.32rem;
  box-sizing: border-box;
  background-color: #ffedde;
  color: #ff843d;
}
</style>



// WEBPACK FOOTER //
// src/components/noticetop.vue